import {Component, ChangeDetectionStrategy} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {SortTable, SortTableRow} from '../../../shared/models/sort-table/types';

@Component({
    template: `./table-view-base.component.html`,
    styleUrls: ['./base-table-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class BaseTableViewComponent {
  table$ = new BehaviorSubject<SortTable>(null);
  protected tableRows: { [key: string | number]: SortTableRow } = {};

  /**
   * Optional for use in extended classes; meant to be set to false
   * once the table should be rendered for the first time
   */
  loading: boolean = true;

  protected constructor() {
  }


  protected abstract updateTable();


  /**
   * For inserting data into a brand new table row or updating an existing
   * table row. The supplied row may be one that has never been or has been
   * rendered before, so care must be taken to update (not replace) the row's
   * columns if updating the contents of the columns' cells themselves. Full
   * replacement will break the reference to the object whose data is
   * actually being shown to the end user, which, again, matters if the cell
   * data needs to be updated. If the cell's contents will never be replaced
   * then full replacement is okay.
   *
   * Below is an @see reference to a good example of where these concerns
   * are taken into account.
   *
   * @see TilesExistingComponent
   * @protected
   */
  protected abstract upsertRowData(row: SortTableRow, ...args);
}
